<template>
    <ButtonIcon
        v-b-tooltip.hover.noninteractive.bottom
        icon="filter"
        :title="$t('restoreFiltersToTheDefaultSettings')"
        class="rounded-circle p-1 height-40 width-40"
        variant="light"
        v-bind="$attrs"
        v-on="$listeners"
    />
</template>



<script>
    export default {
        name: 'ButtonResetFilters',
        data() {
            return {};
        },
    };
</script>
